import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { BootstrapVue } from 'bootstrap-vue'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
// import { EventBus } from '@/helpers/eventBus'
import { Client } from '@microsoft/microsoft-graph-client'
import Toast from 'vue-toastification'
import MarqueeText from 'vue-marquee-text-component'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-toastification/dist/index.css'
import './assets/styles/style.css'
import './registerServiceWorker'
import { checkMemberGroups } from './helpers/graphHelper'

export async function getUserProfile (accessToken) {
  // if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
  //   return {
  //     displayName: 'Jane Doe',
  //     mail: 'jane.doe@lilly.com',
  //     jobTitle: 'Software Developer',
  //     givenName: 'Jane',
  //     surname: 'Doe',
  //     initials: 'JD',
  //     isAdmin: true
  //   }
  // } else {
  const client = Client.init({
    authProvider: (done) => {
      done(null, accessToken)
    }
  })
  try {
    const user = await client.api('/me').select('displayName,mail,jobTitle,givenName,surname').get()
    user.initials = (user.givenName?.charAt(0) || '') + (user.surname?.charAt(0) || '')
    const adminGroupId = process.env.VUE_APP_DEVELOPER_DL.split('@')[0]
    const isAdmin = await checkMemberGroups(accessToken, [`${adminGroupId}`])
    user.isAdmin = isAdmin
    return user
  } catch (error) {
    console.error('Error fetching user profile:', error)
    return null
  }
  // }
}

export async function getUserPhoto (accessToken) {
//   if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
//     // Mock user photo for local env
// const mockUserPhoto = 'https://cdn.vuetifyjs.com/images/lists/5.jpg'
//     return mockUserPhoto
//   } else {
  const client = Client.init({
    authProvider: (done) => {
      done(null, accessToken)
    }
  })
  try {
    const photo = await client.api('/me/photo/$value').responseType('blob').get()
    return URL.createObjectURL(photo)
  } catch (error) {
    console.error('Error fetching user photo:', error)
    return null
  }
  // }
}

// const getCookieValue = (name) => {
//   const cookies = document.cookie.split('; ')
//   for (const cookie of cookies) {
//     const [cookieName, cookieValue] = cookie.split('=')
//     if (cookieName === name) {
//       return decodeURIComponent(cookieValue)
//     }
//   }
//   return null
// }

// export const acquireToken = (account) => {
//   // if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
//   //   return 'local'
//   // } else {
//   const accessToken = account.idToken
//   const userInfo = Vue.prototype.$userInfo
//   userInfo.accessToken = accessToken
//   return accessToken
//   // }
// }

// export const validateToken = () => {
//   const token = acquireToken()
//   if (token) {
//     return true
//   } else {
//     EventBus.$emit('session-expired')
//     return false
//   }
// }

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    authority: process.env.VUE_APP_AUTHORITY,
    redirectUri: process.env.VUE_APP_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
}
const msalInstance = new PublicClientApplication(msalConfig)

// export const login = async () => {
//   try {
//      msalInstance.loginRedirect()
//   } catch (error) {
//     console.error(error)
//   }
// }

const msalPlugin = {
  install (Vue) {
    Vue.prototype.$msal = msalInstance
  }
}

Vue.use(msalPlugin)
Vue.use(BootstrapVue)
Vue.use(Toast, {
  timeout: 20000,
  closeOnClick: false
})
Vue.component('marquee-text', MarqueeText)

const userInfo = Vue.observable({
  photo: null,
  profile: null,
  accessToken: null,
  idToken: null
})

Vue.prototype.$userInfo = userInfo
Vue.config.productionTip = false

async function initializeApp () {
  try {
    console.log('Initializing app...')
    await msalInstance.initialize()
    console.log('MSAL initialized', msalInstance)

    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0])
    }

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account
        msalInstance.setActiveAccount(account)
      }
    })

    let account = msalInstance.getActiveAccount()

    // Handle redirect response and set active account
    await msalInstance.handleRedirectPromise().then(async (authResult) => {
      if (authResult) {
        console.log('Redirect authentication result:', authResult)
        msalInstance.setActiveAccount(authResult.account)
        account = authResult.account
      }
    }).catch(err => {
      console.error('Error handling redirect:', err)
    })

    if (!account) {
      console.log('No active account found. Redirecting to login...')
      await msalInstance.loginRedirect()
      return
    }

    console.log('Active account:', account)

    // Acquire token silently
    const tokenRequest = {
      scopes: ['User.Read'], // Replace with the scopes your app requires
      account: account
    }

    const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest).catch(async (error) => {
      console.warn('Silent token acquisition failed. Falling back to redirect:', error)
      await msalInstance.acquireTokenRedirect(tokenRequest)
    })

    const accessToken = tokenResponse?.accessToken
    console.log('Access token acquired:', accessToken)

    if (!accessToken) {
      console.log('No access token found. Redirecting to login...')
      await msalInstance.loginRedirect()
      return
    } else {
      console.log('Access token:', accessToken)
      userInfo.accessToken = accessToken
    }

    const userProfile = await getUserProfile(accessToken)
    if (userProfile) {
      const photo = await getUserPhoto(accessToken)
      userInfo.profile = {
        displayName: userProfile.displayName,
        mail: userProfile.mail,
        jobTitle: userProfile.jobTitle,
        photo: photo,
        initials: userProfile.initials,
        isAdmin: userProfile.isAdmin,
        accessToken: accessToken
      }
    }

    new Vue({
      router,
      vuetify,
      render: h => h(App),
      mounted () {
        this.applyTheme()
      },
      methods: {
        applyTheme () {
          if (localStorage.getItem('isDarkTheme') === null) {
            this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches
          } else {
            this.$vuetify.theme.dark = localStorage.getItem('isDarkTheme') === 'true'
          }
          window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
            console.log('System preference changed', e)
            this.$vuetify.theme.dark = e.matches
            localStorage.removeItem('isDarkTheme')
          })
        }
      },
      watch: {
        $route (to, from) {
          document.title = to.meta.title || 'Default Title'
        }
      }
    }).$mount('#app')
  } catch (error) {
    console.error('Error during app initialization:', error)
  }
}

initializeApp()
